export enum BranchState {
    ended,
    ready,
    animating,
}
